import Banner from './components/Banner.vue';
import Features from './components/Features.vue';
import { FEATURES_LIST } from './index.js';
import Function from './components/Function';
import Statistics from './components/Statistics';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    Banner,
    Function,
    Features,
    Statistics,
    Appointment2
  },
  data() {
    return {
      featuresList: FEATURES_LIST,
      productId: this.$productId.OPEN_AI.SHU_JU_ZHONG_XIN
    };
  }
};